import { AdminQrDTO } from "../shared/dtos/adminQrDTO";
import PatchAdminQrDTO from "../shared/dtos/PatchAdminQrDTO";
import DefaultPaginationProps from "../propInterfaces/defaultPaginationProps";
import axiosInstance from "../app/axios";

export const getAdminQrByAdminId = async (adminId: number) => {
  const result = await axiosInstance.get(`adminqr/${adminId}`);
  return result.data;
};

export const getAdminQrByCode = async (code: string) => {
  const result = await axiosInstance.get(`adminqr/code/${code}`);
  return result.data;
};

export const createAdminQr = async (
  adminQr: AdminQrDTO,
): Promise<AdminQrDTO> => {
  const result = await axiosInstance.post("adminqr", adminQr);

  return result.data;
};

export const updateAdminQr = async (
  patchAdminQrDTO: PatchAdminQrDTO,
  id?: number,
) => {
  const result = await axiosInstance.patch(
    `adminqr/${id ? id : ""}`,
    patchAdminQrDTO,
  );

  return result;
};

export const deleteAdminQr = async (id: number) => {
  const result = await axiosInstance.delete(`adminqr/${id}`);
  return result.data;
};

export const getAdminQrsByAdminId = async ({
  page,
  take,
}: DefaultPaginationProps) => {
  const result = await axiosInstance.get(
    `adminqr/byuser/aiportqrs?page=${page}&take=${take}`,
  );
  return result.data;
};

